import de_DE from "../../resources/translations/de_DE";

const i18n = (key) => {
    return de_DE[key];
};

export default i18n;